// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"ad7cdb87","453":"9ef3c10a","712":"3e49eb8c","911":"ed6a3583"}[chunkId] + ".chunk.js";
};